import Icon from '@/features/common/components/Overview/parts/ProductItem/parts/OptionRow/parts/Icon'
import Name from '@/features/common/components/Overview/parts/ProductItem/parts/OptionRow/parts/Name'
import Price from '@/features/common/components/Overview/parts/ProductItem/parts/OptionRow/parts/Price'
import { Icon as IconType } from '@/features/common/components/Overview/parts/ProductItem/parts/OptionRow/types'
import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import { TextSize } from '@/features/common/components/Overview/parts/ProductItem/types'
import { FC } from 'react'
import { View } from 'react-native'

interface OptionRowProps {
    icon: IconType
    name: string
    price?: string
    textSize?: TextSize
}

const OptionRow: FC<OptionRowProps> = ({ icon, name, price, textSize = 'normal' }) => {
    return (
        <View style={styles.optionRow}>
            <Icon icon={icon} />
            <Name textSize={textSize}>{name}</Name>
            {price && <Price textSize={textSize}>{price}</Price>}
        </View>
    )
}

export default OptionRow
